import { connect } from 'react-redux';
import SourcePageStep from '../components/SourcePageStep';
import { getBaseSourcesLoading, getSourcePageStep } from '../selectors';
import {
    addFutureChanged,
    changeAllDataSourceSelection,
    changeDataSourceSelection,
    stepValidationStatusChanged,
} from '../actions';

const mapStateToProps = state => ({ ...getSourcePageStep(state), loading: getBaseSourcesLoading(state) });

const mapDispatchToProps = dispatch => {
    return {
        onAllChange: (allSources, value) => dispatch(changeAllDataSourceSelection(allSources, value)),
        onChange: (id, value) => dispatch(changeDataSourceSelection(id, value)),
        enableAddFuture: () => dispatch(addFutureChanged('base_source', true, true)),
        onStepValidationStatusChanged: stepValidationStatus =>
            dispatch(stepValidationStatusChanged(stepValidationStatus)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(SourcePageStep);
